import React, {PropTypes} from 'react';

class SelectionOptions extends React.Component {

  constructor () {
    super();
    this.update = this.update.bind(this);
  }

  update(option, event) {
    this.props.optionsActions.updateOption(option, event.target.checked);
  }

  render() {
    let options = this.props.options;

    return (
      <div>
        <div className="modal" id="options" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div className="modal-dialog modal-sm" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title" id="myModalLabel">Show / hide data</h4>
              </div>
              <div className="modal-body">
                <form>
                  <div className="checkbox">
                    <label>
                      <input type="checkbox" checked={options.display_recommended} onChange={this.update.bind(this, 'display_recommended')} /> Display recommendation
                    </label>
                  </div>
                  <div className="checkbox">
                    <label>
                      <input type="checkbox" checked={options.display_temperatures} onChange={this.update.bind(this, 'display_temperatures')} /> Display temperatures
                    </label>
                  </div>
                  <div className="checkbox">
                    <label>
                      <input type="checkbox" checked={options.display_precipitations} onChange={this.update.bind(this, 'display_precipitations')} /> Display precipitations
                    </label>
                  </div>

                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SelectionOptions.propTypes = {
  options: PropTypes.object.isRequired,
  optionsActions: PropTypes.object.isRequired
};

export default SelectionOptions;



/** WEBPACK FOOTER **
 ** ./src/components/SelectionOptions.js
 **/